import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
import './OnboardingPage.css';

export default function OnboardingPage() {
  const { updateUser } = useAuth();
  const navigate = useNavigate();
  const [selected, setSelected] = useState(null);
  const [saving, setSaving] = useState(false);

  async function handleContinue() {
    if (!selected || saving) return;
    setSaving(true);
    try {
      const res = await api.put('/auth/update-role', { role: selected });
      updateUser({ role: res.data.role });
      navigate('/');
    } catch (err) {
      console.error('Failed to save role:', err);
    } finally {
      setSaving(false);
    }
  }

  const options = [
    {
      value: 'coach',
      emoji: '📋',
      title: 'Team Graphics',
      description: 'Create baseball and softball graphics for game previews, recaps, tryouts, and player spotlights.',
    },
    {
      value: 'parent',
      emoji: '⭐',
      title: 'Player Analytics',
      description: 'Track stats live from the stands, get development insights, and share the big moments.',
    },
    {
      value: 'both',
      emoji: '🏆',
      title: 'Both',
      description: 'Track a player\'s stats and create team graphics.',
    },
  ];

  return (
    <div className="onboarding-page">
      <div className="onboarding-card">
        <div className="onboarding-logo">
          <img src="/logo192.png" alt="Playmaker" />
        </div>
        <h1 className="onboarding-title">Welcome to Playmaker!</h1>
        <p className="onboarding-sub">What do you want to do? You can change this anytime in Account Settings.</p>

        <div className="onboarding-options">
          {options.map((opt) => (
            <button
              key={opt.value}
              className={`onboarding-option${selected === opt.value ? ' selected' : ''}`}
              onClick={() => setSelected(opt.value)}
            >
              <span className="onboarding-option-emoji">{opt.emoji}</span>
              <div className="onboarding-option-text">
                <div className="onboarding-option-title">{opt.title}</div>
                <div className="onboarding-option-desc">{opt.description}</div>
              </div>
              <div className="onboarding-option-check">
                {selected === opt.value ? '✓' : ''}
              </div>
            </button>
          ))}
        </div>

        <button
          className="onboarding-continue"
          onClick={handleContinue}
          disabled={!selected || saving}
        >
          {saving ? 'Saving…' : 'Continue →'}
        </button>

        <p className="onboarding-note">You can change this anytime in your account settings.</p>
      </div>
    </div>
  );
}
